<template>
  <div class="wrapper">
    <nuxt-link event="" :to="homeUrl" @click.native="toExperienceHome('/', 'Vexels')">
      <img
        src="https://cdn.vexels.com/img/logo-variants/default-logo-variant.svg"
        class="vexels-logo"
        :alt="$t('main.header.logo.vexelsLogoAlt')"
        width="130"
        height="29"
      />
    </nuxt-link>
  </div>
</template>

<script>
export default {
  name: 'LogoSection',
  computed: {
    homeUrl() {
      return this.$auth.loggedIn ? this.localePath('/home') : '/';
    }
  },
  methods: {
    toExperienceHome(url, name) {
      this.$ga.event('Top Menu', `Click Button ${name} Top Menu`, this.$route.fullPath);
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.vexels-logo {
  width: 130px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  height: 100%;
  @include xl {
    width: 90px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
